import React from 'react'
import './index.scss'

//other libraries
import { inject, observer } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//material-ui
import CircularProgress from '@material-ui/core/CircularProgress'

//custom components
import CustomTabs from '../../../components/basic/customTabs'
import IssueCardBasicInfo from './basic'
import IssueCardProducts from './products'

@inject('internal')
@inject('translate')
@observer
export default class IssueCardDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
  }
  
  tabsConfig = []
  
  
  componentDidMount() {
    this.props.internal.setRoute(this.props.history, this.props.location.pathname)
    this.setupTabs()
    this.loadBasicData()
  }
  
  setupTabs = () => {
    this.tabsConfig.push(
      {
        label: this.props.translate.i18n.MODULES.ISSUE_CARDS.TABS.BASIC_INFO,
        url: `basic`,
      },
      {
        label: this.props.translate.i18n.MODULES.ISSUE_CARDS.TABS.PRODUCTS,
        url: `products`,
      },
    )
  }
  
  loadBasicData = async (loading = true) => {
    this.setState({ loading })
    let load_data = await api({
      method: 'get',
      url: 'issue-cards/' + this.props.match.params.id,
      authorization: this.props.internal.user.access_token,
    })
    
    if (load_data.success && load_data.success === true) {
      this.props.internal.setDataForSimpeTable(load_data.data.data)
    }
    
    this.setState({ loading: false })
  }
  
  render() {
    const routerData = {
      history: this.props.history,
      location: this.props.location,
      match: this.props.match,
    }
    
    return (
      <div className={'issue-cards-detail-container'}>
        {this.state.loading ?
          <CircularProgress className={'circular-progress'}/>
          :
          <div className={'issue-cards-edit'}>
            <CustomTabs
              title={this.props.internal.dataForSimpeTable.title}
              tabsConfig={this.tabsConfig}
              routerData={routerData}
              module={'/issue-cards'}
            >
              {this.state.loading ? null :
                <IssueCardBasicInfo routerData={routerData}/>
              }
              {this.state.loading ? null :
                <IssueCardProducts routerData={routerData} handleAfterSave={this.loadBasicData}/>
              }
            </CustomTabs>
          
          
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/IssueCards/detail/index.js